import { CometChat } from "@cometchat/chat-sdk-javascript";

import defaultAgentAvatar from "./assets/Profile.png";
// const host: string = window.location.host;
// const path: string = window.location.pathname;

let IS_AGENT_MODE: boolean = false;
let IS_NO_CODE: boolean = false;

// Defaults (preview.cometchat.com/)
IS_AGENT_MODE = false;
IS_NO_CODE = false;

// Check route for AI Agents mode
// if (host === "ai-agents.cometchat.com" || host === "localhost:3000") {
//   IS_AGENT_MODE = true;
//   IS_NO_CODE = true; // Change if no-code applies
// }

const AiAgents = [
  {
    uid: "0d17a2c4-84af-442f-b4f8-221d4f40dd88",
    name: "Demo Agent",
    avatar: defaultAgentAvatar,
    status: "available",
    role: "@agentic",
    metadata: {
      greetingMessage: "Hello User",
      introductoryMessage: "I can help you with weather related information",
      suggestedMessages: [],
    },
    createdAt: 1754571675, // Example timestamp
  },
].map((agent) => {
  const user = new CometChat.User(agent.uid);
  user.setName(agent.name);
  user.setAvatar(agent.avatar);
  user.setStatus(agent.status);
  user.setRole(agent.role);
  user.setMetadata(agent.metadata);
  return user;
});

const COMETCHAT_CONSTANTS = {
  APP_ID: "2801689c9d78bdaf",
  REGION: "us",
  AUTH_KEY: "82b901a84d79abd8720d15c1f4b13c6ea3f2b9c2",
  LOGGED_IN_USER_ID: "",
  AUTH_TOKEN_URL: "https://ai-demo-service.cometchat.io/auth-token",
};

export { IS_AGENT_MODE, IS_NO_CODE, AiAgents, COMETCHAT_CONSTANTS };
